import React from 'react';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import {useLocation} from 'react-router-dom';
import {buildSafeHref} from 'utils/urlSanitization';

const StyledTabAnchorLinks = styled.div`
  display: flex;
  gap: 24px;
`;

const StyledTab = styled(Button)`
  color: ${props => props.theme.grey}80;
  font-size: 24px;
  text-transform: uppercase;
  font-family: 'Trade Gothic Bold Condensed';
  padding: 0;
  transition: color 250ms, background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  &:hover,
  &.active {
    color: ${props => props.theme.activeStateBlue};
  }

  .MuiButton-label {
    border-bottom: 6px solid transparent;
    transition: border-color 250ms;
  }
  &.active .MuiButton-label {
    border-bottom: 6px solid ${props => props.theme.activeStateBlue};
  }
`;

interface TabAnchorLinksProps {
  highlightedTab: string;
  sites: {siteId: string; idf: string | undefined}[];
}

export default function TabAnchorLinks({highlightedTab, sites}: TabAnchorLinksProps) {
  const location = useLocation();
  const {pathname, search} = location;

  return (
    <StyledTabAnchorLinks>
      {sites.map(site => {
        const tabId = `${site.siteId}-${site.idf}`;
        const isActive = decodeURIComponent(highlightedTab) === tabId;
        const safeHref = buildSafeHref(pathname, search, tabId);
        return (
          <StyledTab
            href={safeHref}
            className={isActive ? 'active' : ''}
            key={`tab-${site?.siteId}-${site?.idf}`}
          >
            {site.idf}
          </StyledTab>
        );
      })}
    </StyledTabAnchorLinks>
  );
}
